import { Routes } from '@angular/router';
import { CockpitComponent } from './cockpit/cockpit.component';
import { IsAuthenticatedGuardSort } from '@sortapp/guards/is-authenticated.guard';
import { VorschlagsdetailsComponent } from './vorschlagsdetails/vorschlagsdetails.component';
import { PagenotfoundComponent } from 'FoxxyLib';

export const routes: Routes = [
  { path: '', component: CockpitComponent, canActivate: [IsAuthenticatedGuardSort]     },
  { path: 'calendar',   loadComponent: () => import('../app/calendar/calendar.component').then(c => c.CalendarComponent), canActivate: [IsAuthenticatedGuardSort] },
  { path: 'vorschlagsdetails', component: VorschlagsdetailsComponent, canActivate: [IsAuthenticatedGuardSort] },
  { path: 'sortimentieren', loadChildren: () => import('./sortimentieren/sortimentieren.module').then(m => m.SortimentierenModule),
    canActivate: [IsAuthenticatedGuardSort]},
   { path: 'einkauf', loadChildren: () => import('./sortimentieren/einkauf.module').then(m => m.EinkaufModule), canActivate: [IsAuthenticatedGuardSort]},


  { path: '**', component: PagenotfoundComponent },

];
